<template>
  <div id="home-view">
    <div class="intro-container">
      <div class="language-selector-container">
        <language-selector></language-selector>
      </div>
      <div class="home-logo">
        <img class="logo" src="~@/../static/images/logo-black.svg"/>
      </div>
      <div class="home-content">
        <div class="selma-container">
          <transition name="fade-image">
            <img class="selma-img" src="~@/../static/images/salma.svg" v-on:load="onImgLoaded" v-show="imgLoaded" />
          </transition>
        </div>
        <div class="intro par" v-if="startAnimation">
          <strong>{{$t('home.hello')}}</strong><br/>
          {{$t('home.par1')}}
          <div v-if="!isMobile" class="sub-par">
            {{$t('home.par2')}}
          </div>
          <a @click="scrollToLink" v-if="isMobile">
            <div class="scroll"></div>
          </a>
          <div class="links-container" v-if="!isMobile">
            <router-link tag="div" class="link link-story" to="/story">
              {{$t('home.discover')}}
              <span class="sub" v-if="lang != 'ar'">Rehla</span>
            </router-link>
            <router-link tag="div" class="link link-kit" to="/kit">
              {{$t('home.hear')}}
              <span class="sub" v-if="lang != 'ar'">Koutayeb</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div id="links">
      <div class="par" v-if="isMobile">
        {{$t('home.par2')}}
      </div>
      <div class="links-container" v-if="isMobile">
        <router-link tag="div" class="link link-story" to="/story">
          {{$t('home.discover')}}
          <span class="sub" v-if="lang != 'ar'">Rehla</span>
        </router-link>
        <router-link tag="div" class="link link-kit" to="/kit">
          {{$t('home.hear')}}
          <span class="sub" v-if="lang != 'ar'">Koutayeb</span>
        </router-link>
      </div>

    </div>
    <div class="about-info">
      <span v-if="!isMobile">{{$t('home.about')}}</span>
      <router-link :to="'/about'">
        <div class="know-more-button">{{$t('home.knowMore')}}</div>
      </router-link>
    </div>
    <div class="logo-container">
      <div class="logo-irkchf"><img src="~@/../static/logo/IRCKHF-Logo.jpg"></div>
      <div class="logo-d4c"><img src="~@/../static/logo/D4C_Black.svg"></div>
    </div>
  </div>
</template>

<script>
import LanguageSelector from "@/components/LanguageSelector";
 
export default {
  name: "home",
  components: {LanguageSelector},
  data () {
    return {
      startAnimation: false,
      imgLoaded: false
    }
  },
  computed: {
    isMobile(){
      return this.$store.state.isMobile
    },
    lang (){
      return this.$i18n.locale
    }
  },
  methods: {
    scrollToLink () {
      //this.$el.scrollTop = 200
      this.$SmoothScroll(this.$el.querySelector('#links'), 300, null, this.$el);
    },
    onImgLoaded () {
      this.imgLoaded = true
    }
  },
  mounted () {
    this.startAnimation = true
  }
}
</script>

<style lang="stylus">
#home-view
  min-height: 100vh;
  max-height: 100vh;
  background: #FFF;
  overflow: auto;
  .language-selector-container
      width: 90%;
      margin auto
      padding-top 20px
      padding-bottom 20px
      display: flex;
      justify-content: center
      background: none;
      color: black
      #language-selector
        width 220px

        border-color: #606060
        div
          color: #606060
          &.active
            color: #606060
          &:last-child
            border-color: #606060
  .intro-container
    min-height: 100vh;
    background: #FEe852;
    padding-bottom: 400px;

  .logo
    width: 190px;
    margin-top: 20px;

  .par
    width: 70%;
    margin-left: 15%;
  
  .sub-par
    margin-top: 0px;

  .home-content
    display: flex;
    flex-direction: column;
  
  .selma-container
    min-width: 90%;
    margin: auto;


  .selma-img
    width: 90%;
    margin: auto;
    z-index -1

  .intro
    margin-top: -100px;
  
  .scroll
    background: url('~@/../static/icons/chevron-down-grey.svg') no-repeat center center;
    background-size: 12px;
    min-width: 40px;
    min-height: 40px;
    cursor: pointer;

  .links-container
    flex-direction: column;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 30px;
  
  .link
    display: block;
    width: 200px;
    height: 200px;
    box-shadow: 0px 3px 6px #cdcdcd;
    border-radius: 100px;
    background: #fff;
    line-height: 110px;
    vertical-align: middle;
    margin-bottom: 20px;
    text-align: center;
    cursor: pointer;

  .link .sub
    display: block;
    margin-top: 0px

  .link.link-story
    color: #EAC900;
    background: url("~@/../static/images/story-logo-yellow.svg") no-repeat center center #fff;
    background-size: 100px
  
  .link.link-kit
    color: #72E3C3;
    background: url("~@/../static/images/kit-logo-green.svg") no-repeat center center #fff;
    background-size: 100px

  #links
    margin-top: -350px;
  

  .about-info
    display: flex;
    justify-content: center;
    margin-bottom: 30px;
    margin-top: 30px;
  

  .about-info .know-more-button
    background: #FFF;
    display: flex;
    align-items: center;
    font-size: 15px;
    font-weight bold
    color: #000000;
    background-color: #4DC499
    border-radius: 6px;
    box-shadow: 0pt 3pt 6pt rgba(0,0,0, 0.16);
    min-height: 45px;
    min-width: 300px;
    max-width: 300px;
    padding: 5px;
    cursor: pointer;
    justify-content: center;

  .about-info  a
    text-decoration: none;
  

  .logo-container 
    display: flex;
    border-top:1px solid #E3E3E3;
    height: 80px;
    width: 100%;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap
  
  .logo-container img
    height 45px;
    margin: 5px;



@media only screen and (max-width: 768px) 
  #home-view
    text-align: center


@media only screen and (min-width: 768px)
  #home-view
    .language-selector-container
      width: 90%;
      margin auto
      padding-top 20px
      display: flex;
      justify-content: flex-end
      background: none;
      color: black
      #language-selector
        width 220px

        border-color: #606060
        div
          color: #606060
          &.active
            color: #606060
          &:last-child
            border-color: #606060

    .home-logo
      margin-left: 10%;
      margin-right: 60%;
      padding-top: 20px;
      background: #FEe852;

    .logo 
      text-align: left;
      margin-left: 10%;
      margin-top: 10%;
      width: 200px;

    .home-content
      flex-direction: row-reverse;
    
    .selma-container 
      min-width: 50%;
      margin-top: -12%;
      text-align center
    
    .intro-container 
      padding-bottom: 20px;

    .intro 
      margin-top: 60px;
      margin-left: 10%;

    #links
      margin-top: 0px;

    .links-container
      flex-direction: row;
      margin-top: 00px;

    .link
      min-width: 180px;
      max-width: 180px;
      height: 180px;
      border-radius: 180px;
      margin: 30px 5%;
      .sub
        margin-top -30px


    .about-info
      text-align: center;
      align-items: center;
      flex-direction: column;

    .about-info span
      width: 60%;
      margin-bottom: 20px;
      font-size: 16px;
      font-weight: 200;

    .about-info .know-more-button
      min-width: 300px;


    .logo-container 
      border: none;
      margin-bottom: 20px;

    .logo-container img
      margin: 10px;

</style>



// WEBPACK FOOTER //
// src/views/Home.vue